<template lang="pug">
.loading-screen(v-if="visible")
  .loading-info
    span {{ $t('strings.please_wait') }}
    Loader
</template>

<script>
export default {
  name: 'LoadingScreen',
  components: {
    Loader: () => import('@/components/elements/Loader.vue')
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="sass" scoped>
.loading-screen
  z-index: 999999
  left: 0
  top: 0
  width: 100%
  height: 100vh
  position: fixed
  display: flex
  align-content: center
  justify-content: center
  flex-direction: column
  background: rgba(255, 255, 225, 0.8)
  .loading-info
    text-align: center
    font-size: 1.2rem
    color: #666
</style>
